import { useLingui } from "@lingui/react";
import { Button } from "@/components/ui/button";
import { BarChart3Icon, TableIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ViewMode } from "@/types/cockpit";

interface ChartTableToggleProps {
  mode: ViewMode;
  onModeChange: (mode: ViewMode) => void;
}

export function ChartTableToggle({ mode, onModeChange }: ChartTableToggleProps) {
  const { i18n } = useLingui();

  return (
    <div className="flex items-center gap-1 border rounded-md p-0.5">
      <Button
        variant="ghost"
        size="sm"
        className={cn("h-7 px-2", mode === "chart" && "bg-muted")}
        onClick={() => onModeChange("chart")}
        aria-label={i18n._({ id: "cockpit.toggle.chart", message: "Chart view" })}
      >
        <BarChart3Icon className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className={cn("h-7 px-2", mode === "table" && "bg-muted")}
        onClick={() => onModeChange("table")}
        aria-label={i18n._({ id: "cockpit.toggle.table", message: "Table view" })}
      >
        <TableIcon className="h-4 w-4" />
      </Button>
    </div>
  );
}
